import React from 'react';
const RangoInfo = ({ tipo, rango }) => {
    if (!rango) return null;
    return (
        <div className="card small">
            <div className="card-header bg-primary text-white text-center p-2">
                {tipo}
            </div>
            <div className="card-body p-2">
                <p className="mb-1"><strong>Óptimo:</strong> {rango.optimo}</p>
                <p className="mb-1"><strong>Min:</strong> {rango.minimo}</p>
                <p className="mb-1"><strong>Max:</strong> {rango.maximo}</p>
            </div>
        </div>
    );
};
export default RangoInfo;